/* eslint-disable react/no-array-index-key */
import React from 'react';

import classNames from 'classnames';

import { Link } from 'react-router-dom';
import { ReactComponent as Back } from 'assets/svg/back.svg';
import useDevice from '../../hooks/useDevice';
import Backdrop from './Backdrop';
import { MENU_ITEMS } from '../../constants/menu';
import { usePermissions } from '../../hooks/usePermissions';

function SideDrawer({ show, setOpenDrawer, drawer, collapsed }) {
  const { can } = usePermissions();
  const { isMobile, isMobileSm } = useDevice();
  // const isMobile = width < TAB_SIZE;
  const drawerClasses = classNames({
    'omi-side-drawer animate__animated animate__faster': true,
    'menu-collapse': collapsed,
    hidden: show === undefined,
    animate__slideOutLeft: !show && show !== undefined,
    animate__slideInLeft: show,
    'menu-mobile-collapse': show && isMobile,
  });
  const backdropClickHandler = () => {
    setOpenDrawer(false);
  };
  let backdrop;
  if (show) {
    backdrop = <Backdrop click={backdropClickHandler} />;
  }

  return (
    <>
      {backdrop}
      <nav className={drawerClasses}>
        <p className={classNames({ 'omi-sidebar-header-mobile': isMobileSm, 'omi-sidebar-header': true })}>
          {isMobileSm && <Back onClick={() => setOpenDrawer(false)} />}
          {MENU_ITEMS[drawer] && MENU_ITEMS[drawer].name}
        </p>

        <div className="omi-sidebar-body">
          {MENU_ITEMS[drawer] &&
            MENU_ITEMS[drawer].items.map((item, key) => {
              const location = {
                pathname: item.link,
                state: item.state ? item.state : '',
              };

              if (item.permission && !can(item.permission)) {
                return null;
              }

              return (
                <Link key={key} to={location} onClick={() => setOpenDrawer(false)}>
                  <p>{item.name}</p>
                </Link>
              );
            })}
        </div>
      </nav>
    </>
  );
}

export default SideDrawer;
